import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChild, ViewChildren, OnDestroy } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { EIPAutoCompleteComponent } from "eipauto-complete";
import { BehaviorSubject, Subscription } from "rxjs";
import { DynamicFormComponent } from "src/app/CommonComponents/dynamic-form/components/dynamic-form/dynamic-form.component";
import { FieldConfig } from "src/app/CommonComponents/dynamic-form/interface/field.interface";
import { CommonService } from "src/app/Service/Common.service";
import { DocumentRevisionLinkService } from "src/app/Service/document-revision-link/document-revision-link.service";
import { Module } from "src/app/Service/element-details.data.service";
import { NotificationService } from "src/app/Service/notification.service";
import { ProjectInfoService } from "src/app/Service/project-info/project-info.service";
import { ScheduleDefinitionService } from "src/app/Service/scheduledefintion/scheduledefintion.service";
import { ScheduleDocumentService } from "src/app/Service/scheduledocument/scheduleDocument.service";
import { BusinessGroupModel } from "src/app/ViewModel/BusinessGroupModel";
import { IDocSLNoInputModel, IElementInputModel } from "src/app/ViewModel/DocumentModel";
import { IDCIRevisionMaster, IProjectElementDetailsOutput, IProjectElementsOutput, IProjectFeatureOutput } from "src/app/ViewModel/ProjectElementsModel";
import { IDocSetModel, IScheduleElementDetails, IStageElementDetails } from "src/app/ViewModel/ScheduleDefinitionModel";
import { ICPCDocOutputModel, ICPCInputModel, IRevisionCategory, IScheduleBulkInsertModel, IScheduleDocDetails, IScheduleDocElementDetails, IScheduleDocModel, IScheduleDocRevModel, IScheduleDocStageDetails, IScheduleMHDetails, IScheduleStageId, IScheduleType, IScheduleWFPlanDetails, IScheduleWFPlanStageDetails, IScheduleWorkflowDetails, IWBSOutputModel } from "src/app/ViewModel/ScheduleDocumentModel";
import { StandardOutputModel } from "src/app/ViewModel/StandardOutputModel";
import { WorkflowTemplateModel } from "src/app/ViewModel/WorkflowTemplateModel";
import { ElementLinkService } from 'src/app/Service/element-link/element-link.service';
import { IProjectMasterViewModel } from "src/app/ViewModel/ProjectMasterModel";
import { ProjectMasterService } from "src/app/Service/projectmaster/projectmaster.service";
import { EIPAutoCompleteEventModel } from "src/app/ViewModel/EIPAutoCompleteEventModel";
import { FileUploadComponent } from 'src/app/CommonComponents/file-upload/file-upload.component';
import { MatDialog } from '@angular/material/dialog';

export enum FileUploadLibrary {
    WorkflowDocument = 1,
    Documents = 2,
    CCNDocuments = 3,
    Communication = 4,
    SignedDocuments = 5
}

interface IStageDates {
    minDate: Date,
    maxDate: Date,
    value: Date
}
@Component({
    selector: 'app-schedule-creation',
    templateUrl: './schedule-creation.component.html',
    styleUrls: ['./schedule-creation.component.css']
})
export class ScheduleCreationComponent implements OnInit, OnDestroy {
    projectId!: number;
    groupId!: number;
    memberId!: number;
    @Input() docIndex: number = 0;
    private _numFormat: string = 'Auto';
    get numFormat(): string {
        return this._numFormat;
    }
    @Input() set numFormat(val: string) {
        this._numFormat = val;
        if (val == 'Auto' || val == 'Manual')
            this.readonly = true;
        else {
            this.readonly = false;
        }
        this.enableDisableSerialNo(true);
    }
    @Input() readonly!: boolean;
    @Input() isStdDCI!: boolean;
    @Input() autoSerialNoMap: Map<number, number> = new Map<number, number>();
    @Input() sourceDciComponent!: ScheduleCreationComponent;
    @Output() getDocumentSerialNo = new EventEmitter<any>();
    clickButton = true;
    panelOpenState = true;
    projectElements: IProjectElementsOutput[] = [];
    projectStaticElements: IProjectElementsOutput[] = [];
    isAutoRevision: boolean = false;
    isDocSetRequired: IProjectElementsOutput;
    isWBSIntegration: boolean = false;
    SetDCIMaxProgressLevel: IProjectElementsOutput;
    setDocSetRequiredElement: IProjectElementsOutput;
    isAutoEnabled: boolean = true;
    elementsConfig: FieldConfig[] = [];
    numElements: Map<string, string> = new Map<string, string>();
    elementInp?: IElementInputModel[] = [];
    //inputRequiredOptions: any[] = [{ value: true, name: "Required" }, { value: false, name: "Not Required" }];
    schTypeOptions: IScheduleType[] = [{ schType_Id: 1, schType_Name: "DCI" }, { schType_Id: 2, schType_Name: "Ext DCI" }, { schType_Id: 3, schType_Name: "Std DCI" }, { schType_Id: 4, schType_Name: "Vendor DCI" }];
    projBusinessGroups: BusinessGroupModel[] = [];
    selectedApprovalBy!: number;
    revCategoryList: IRevisionCategory[] = [];
    selectedRevCategory!: number;
    workflowList: WorkflowTemplateModel[] = [];
    selectedWorkflow!: number;
    docSetList: IDocSetModel[] = [];
    filteredDocSetList: IDocSetModel[] = [];
    selectedDocSet?: number;
    selectedDocSetStageDetails: IStageElementDetails[] = [];
    selectedDocSetStageDetailsCopy: IStageElementDetails[] = [];
    IsDisabled: boolean = true;
    stageDates: Map<string, IStageDates> = new Map<string, IStageDates>();
    @ViewChild("docSetForm")
    dynamicForm!: DynamicFormComponent;
    @ViewChildren(EIPAutoCompleteComponent)
    eipAutoCompleteComponents!: QueryList<EIPAutoCompleteComponent>;
    dciForm!: FormGroup;
    docScheduleForm!: FormGroup;
    revForm!: FormGroup;
    dciSerialNo?: number | null;
    printSizeList: IProjectElementDetailsOutput[] = [];
    selectedPrintSize!: number;
    dciStatusList: IProjectElementDetailsOutput[] = [];
    selectedDciStatus!: number;
    approverList: IProjectFeatureOutput[] = [];
    dciRevisionList: IDCIRevisionMaster[] = [];
    selectedAuthorisedBy!: number;
    scheduleWFPlanStageDetails: IScheduleWFPlanStageDetails[] = [];
    structPackEleId!: number;
    discEleId!: number;
    structSelectedDedId!: number;
    discSelectedDedId!: number;
    isShowSerialNo!: boolean;
    serialNoLength: number = 5;
    wbsList: any = [];
    dvcodeList: any = [];
    JOBCode!: string;
    WBSCode!: string | null;
    DeliverableCode!: number | null;
    WTemplateStage: any = [];
    selectedschtype: number = 1;
    UnSubscribe: Subscription[] = [];
    G_workflowList: any;
    ProgressLevelsList: IProjectElementDetailsOutput[] = [];
    selectedMaxProgressLevel: number;
    // validationMsg:boolean = false;

    constructor(private _projService: ProjectInfoService,
        private _scheduleDocService: ScheduleDocumentService,
        private _notificationService: NotificationService,
        private _elementLinkService: ElementLinkService,
        private _commonService: CommonService,
        private _formBuilder: FormBuilder,
        private _scheDefService: ScheduleDefinitionService,
        public _datepipe: DatePipe,
        private _dciRevMaster: DocumentRevisionLinkService,
        private _projectService: ProjectMasterService,
        private dialog: MatDialog
    ) {
        this.createDCIForm();
    }

    ngOnInit() {
        this.projectId = this._commonService.getProjectId();
        this.groupId = this._commonService.getLoggedInUserGroupId();
        this.memberId = this._commonService.getLoggedInUserId();
        this.getProjectStaticElements();
        this.getStructureDiscElementId();
        this.getDynamicForm();
        this.getElementDetails("Print Size", Module.ScheduleDocument);
        this.getElementDetails("Status", Module.ScheduleDocument);
        this.getElementDetails("Progress Level", Module.Workflow);
        this.getApproverList();
        this.getProjectBusinessGroups();
        this.getWorkflowDetails();
        this.getRevisionCategories();
        this.getProjectRevisionMaster();
        this.getSerialNoLength();
        //this.dciForm.get('inputRequired')?.setValue(this.inputRequiredOptions[1]);
        this.dciForm.get('schType')?.setValue(this.schTypeOptions[0]);
        this.getWBSCodes();
        if (this.isStdDCI) {
            this.schTypeOptions = [{ schType_Id: 3, schType_Name: "Std DCI" }];
            this.selectedschtype = 3;
            this.dciForm.get('schType')?.setValue(this.schTypeOptions[0]);
            this.revForm.get('revision')?.setValue(0);
        }
        else {
            this.schTypeOptions = [{ schType_Id: 1, schType_Name: "DCI" }, { schType_Id: 2, schType_Name: "Ext DCI" }, { schType_Id: 4, schType_Name: "Vendor DCI" }];
            this.selectedschtype = 1;
            this.dciForm.get('schType')?.setValue(this.schTypeOptions[0]);
        }
        if (!!this.sourceDciComponent) {
            this.copyGeneralDetails();
            let schType: IScheduleType = this.sourceDciComponent.dciForm.get('schType')?.value;
            this.schTypeOptions = [{ schType_Id: 1, schType_Name: "DCI" }, { schType_Id: 2, schType_Name: "Ext DCI" }, { schType_Id: 4, schType_Name: "Vendor DCI" }];
            this.selectedschtype = schType.schType_Id;
            this.dciForm.get('schType')?.setValue(this.schTypeOptions.find(x => x.schType_Id == schType.schType_Id));
        }
    }

    createDCIForm() {
        this.dciForm = this._formBuilder.group({
            dciSerialNo: new FormControl({ value: '', disabled: true }, Validators.required),
            dciSemiNo: new FormControl({ value: '', disabled: true }, [Validators.pattern("^[0-9]*$")]),
            title: new FormControl('', [Validators.required]),
            enggManhours: new FormControl('', [Validators.pattern("^[0-9]*\.?[0-9]*$")]),
            draftingManHours: new FormControl('', [Validators.pattern("^[0-9]*\.?[0-9]*$")]),
            weightage: new FormControl('', Validators.pattern("^[0-9]*\.?[0-9]*$")),
            inputRequired: new FormControl('Required'),
            schType: new FormControl('DCI'),
            wbsCode: new FormControl(),
            dvCode: new FormControl()
        });
        this.docScheduleForm = this._formBuilder.group({
            approvalBy: new FormControl('', Validators.required),
            formApprovalBy: new FormControl('', Validators.required),
            workflow: new FormControl('', Validators.required),
            formWorkflow: new FormControl('', Validators.required),
            docSet: new FormControl('', [Validators.required]),
            formDocSet: new FormControl('', [Validators.required]),
            MaxProgressLevel: new FormControl(),
            formMaxProgressLevel: new FormControl(),
        });
        this.revForm = this._formBuilder.group({
            dciStatus: new FormControl('', [Validators.required]),
            formDciStatus: new FormControl('', [Validators.required]),
            revision: new FormControl({ value: '', disabled: true }, [Validators.required]),
            authorisedBy: new FormControl('', [Validators.required]),
            formAuthorisedBy: new FormControl('', [Validators.required]),
            qrCodeTag: new FormControl(true),
            reference: new FormControl(),
            noOfSheets: new FormControl(),
            printSize: new FormControl('', Validators.required),
            formPrintSize: new FormControl('', Validators.required),
            revCategory: new FormControl('', Validators.required),
            formrevCategory: new FormControl('', Validators.required),
            isConfidential: new FormControl(false),
            comments: new FormControl()
        });
    }

    getDynamicForm() {
        let _getProjectElements = this._projService.getProjectElements({ projectId: this.projectId, groupId: this.groupId, moduleId: Module.ScheduleDocument, IsQueryForStaticElement: false }).subscribe(
            (res: IProjectElementsOutput[]) => {
                this.projectElements = res;
                this.elementsConfig = res.map(x => {
                    let field: FieldConfig;
                    let childDEId = null;
                    let childDEDescription = "";
                    let data = res.filter(item => item.dependentElementId == x.elementId);

                    if (data.length > 0) {
                        childDEId = data[0].elementId;
                        childDEDescription = data[0].elementDescription;
                    }

                    field = {
                        de_id: x.elementId,
                        module_id: Module.ScheduleDocument,
                        dependent_de_id: x.dependentElementId,
                        dependent_de_Description: x.dependentElementDescription,
                        child_de_id: childDEId,
                        child_de_Description: childDEDescription,
                        name: x.elementDescription,
                        deDescription: x.elementDescription,
                        type: 'select',
                        value: new BehaviorSubject(null)
                    }
                    if (x.isMandatory) {
                        field.validations = [
                            {
                                name: "required",
                                validator: Validators.required,
                                message: field.name + " Required"
                            }
                        ]
                    }
                    if (x.isNumbering) {
                        this.numElements.set(x.elementDescription, '');
                    }
                    return field;
                });
                this.dynamicForm.fields = this.elementsConfig;
                this.dynamicForm.createControl();
                this.buildScheduleDocumentNumber();
                this.onCascadingAutocomplete_Change();
                //Discipline & Structure changes should be subscribed when doc set is required
                if (this.isDocSetRequired) {
                    this.subscribeDiscStructureChanges();
                    this.loadStages();
                }
                else {
                    this.loadWorkflowStages();
                }
                if (!!this.sourceDciComponent)
                    this.copyElementDetailsFromSource();
            });
        this.UnSubscribe.push(_getProjectElements);
    }

    async getSerialNoLength() {
        let slNoArray = await this._elementLinkService.getNumberingSlNoLength(this.projectId, this.groupId, Module.ScheduleDocument).toPromise();
        this.serialNoLength = slNoArray.serialNoLength != 0 ? slNoArray.serialNoLength : 5;
    }

    onCascadingAutocomplete_Change() {
        this.elementsConfig.forEach(data => {
            if (!!data.child_de_id && data.deDescription) {
                this.dynamicForm.form.get(data.deDescription)?.valueChanges.subscribe(x => {
                    let resForm: FormGroup = this.dynamicForm.value;
                    let _field = this.dynamicForm.getCascadingAutocompleteDetails(data.child_de_Description);
                    let parentControlSelectedValue: IProjectElementDetailsOutput = resForm.get(data.deDescription).value;

                    if (_field.length > 0 && !!parentControlSelectedValue) {
                        this._projService.getProjectElementCascadingDetails({
                            projectId: this.projectId,
                            groupId: this.groupId,
                            moduleId: Module.ScheduleDocument,
                            deId: _field[0].de_id,
                            deDescription: _field[0].deDescription,
                            dependentDEId: _field[0].dependent_de_id,
                            dependentDEDId: parentControlSelectedValue.dedId
                        }).subscribe((res: IProjectElementDetailsOutput[]) => {
                            if (res.length > 0) {
                                res.map(val => val.displayText = (val.dedShortDescription!! && val.dedShortDescription.trim().length > 0 ? (val.dedShortDescription + " - ") : "") + val.dedDescription);
                                _field[0].values = res;
                            }
                            else {
                                _field[0].values = [];
                                /*this._projService.getProjectElementDetails({
                                    projectId: this.projectId,
                                    groupId: this.groupId,
                                    moduleId: Module.ScheduleDocument,
                                    deId: _field[0].de_id,
                                    deDescription: _field[0].deDescription
                                }).subscribe((res: IProjectElementDetailsOutput[]) => {
                                    if (res.length > 0) {
                                        res.map(val => val.displayText = val.dedShortDescription + " - " + val.dedDescription);
                                        _field[0].values = res;
                                    }
                                }, err => { });*/
                            }
                        }, err => { });
                    }
                    else {
                        _field[0].values = [];
                        /*this._projService.getProjectElementDetails({
                          projectId: this.projectId,
                          groupId: this.groupId,
                          moduleId: Module.Transmittal,
                          deId: _field[0].de_id,
                          deDescription: _field[0].deDescription
                        }).subscribe((res: IProjectElementDetailsOutput[]) => {
                          if (res.length > 0) {
                            res.map(val => val.displayText = val.dedShortDescription + " - " + val.dedDescription);
                            _field[0].values = res;
                          }
                        }, err => { });*/
                    }
                })

            }
        })
    }

    /**
    *Get Document Serial No
    */
    GetDocumentSerialNo() {
        //Coin the Schedule Document number based on the element values selection changes
        let elementValues: string[] = Array.from(this.numElements.values());
        let selectedElementValues: string[] = elementValues.filter(val => val != '');
        let docNo: string = elementValues.filter(val => val != '').join('-');
        this.dciForm.get('dciSerialNo')?.setValue(docNo);
        //Ensure all the mandatory numering elements selected
        if (elementValues.length > 0 && elementValues.length == selectedElementValues.length) {
            let resForm: FormGroup = this.dynamicForm.value;
            this.elementInp = this.projectElements.filter(x => x.isNumbering).map(x => {
                let selectedValue: IProjectElementDetailsOutput = resForm.get(x.elementDescription).value;
                if (!!selectedValue) {
                    let result: IElementInputModel = {
                        deId: x.elementId,
                        dedId: selectedValue.dedId,
                        deDescription: x.elementDescription,
                        dedDescription: selectedValue.dedDescription,
                        dedShortDescription: selectedValue.dedShortDescription,
                        sortBy: +selectedValue.sortBy
                    }
                    return result;
                }
            });
            let inputModel: IDocSLNoInputModel = { projectId: this._commonService.getProjectId(), groupId: this.groupId, moduleId: Module.ScheduleDocument, elementDetails: this.elementInp };
            let _GetDocSerialNo = this._scheduleDocService.GetDocSerialNo(inputModel).subscribe((result: StandardOutputModel) => {
                //Updates the serial no based on remaining document selected ded ids
                this.getDocumentSerialNo.emit({ index: this.docIndex, selectedDedIds: this.elementInp, serialNo: result.successCode });
                //Set manipulated value from the parent component(W.r.t other documents elements selection while bulk upload)
                this.dciSerialNo = this.autoSerialNoMap.get(this.docIndex);
                this.dciForm.get('dciSemiNo')?.setValue(String(this.dciSerialNo).padStart(this.serialNoLength, '0'));
                this.enableDisableSerialNo(false);
            });
            this.UnSubscribe.push(_GetDocSerialNo);
        }
    }
    /**
    * Get Project business groups
    */
    getProjectBusinessGroups() {
        let _getProjectBusinessGroups = this._commonService.getProjectBusinessGroups(this._commonService.getProjectId()).subscribe(res => {
            this.projBusinessGroups = res.filter(x => x.is_Active);
            if (!!this.sourceDciComponent) {
                let businessGroup: BusinessGroupModel = this.sourceDciComponent.docScheduleForm.get('approvalBy')?.value;
                if (!!businessGroup) {
                    this.selectedApprovalBy = businessGroup.group_Id;
                    this.setFormValue(this.docScheduleForm, "formApprovalBy", this.selectedApprovalBy);
                }
            }
            else if (res.length == 1) {
                this.selectedApprovalBy = res[0].group_Id;
                this.setFormValue(this.docScheduleForm, "formApprovalBy", this.selectedApprovalBy);
            }
        });
        this.UnSubscribe.push(_getProjectBusinessGroups);

    }


    changeButtonToggle(event: { value: { schType_Id: number; }; }) {
        this.selectedschtype = event.value.schType_Id;
        this.workflowList = JSON.parse(this.G_workflowList);
        this.LoadWorkflowDetails();
    }

    getWorkflowDetails() {
        let _GetWorkflowList = this._scheduleDocService.GetWorkflowList().subscribe((x: WorkflowTemplateModel[]) => {
            this.workflowList = x.filter(x => !x.cnN_Required);
            this.G_workflowList = JSON.stringify(x.filter(y => !y.cnN_Required));
            this.LoadWorkflowDetails();
        });
        this.UnSubscribe.push(_GetWorkflowList);
    }
    LoadWorkflowDetails() {
        this.workflowList = this.workflowList.filter(x => x.scheduleType == this.selectedschtype && !x.cnN_Required);
        if (!!this.sourceDciComponent) {
            let workflow: WorkflowTemplateModel = this.sourceDciComponent.docScheduleForm.get('workflow')?.value;
            if (!!workflow) {
                this.selectedWorkflow = workflow.workflowId;
                this.setFormValue(this.docScheduleForm, "formWorkflow", this.selectedWorkflow);
            }
        }
        else if (this.workflowList.length == 1) {
            this.selectedWorkflow = this.workflowList[0].workflowId;
            this.setFormValue(this.docScheduleForm, "formWorkflow", this.selectedWorkflow);
        }
    }

    getRevisionCategories() {
        this.revCategoryList = [{ revCategoryId: 1, revCategory: 'Minor' }, { revCategoryId: 2, revCategory: 'Major' }, { revCategoryId: 3, revCategory: 'First Release' }];
        if (!!this.sourceDciComponent) {
            let revisionCategory: IRevisionCategory = this.sourceDciComponent.revForm.get('revCategory')?.value;
            if (!!revisionCategory) {
                this.selectedRevCategory = revisionCategory.revCategoryId;
                this.setFormValue(this.revForm, "formrevCategory", revisionCategory.revCategory);
            }
        }
    }

    getProjectRevisionMaster() {
        let obj = {
            "projectId": this.projectId,
            "groupId": this.groupId,
        }
        let _getDocumentRevision = this._dciRevMaster.getDocumentRevision(obj).subscribe((data: IDCIRevisionMaster[]) => {
            this.dciRevisionList = data;
        })
        this.UnSubscribe.push(_getDocumentRevision);
    }

    /**
    * Load document set list
    */
    getDocSetList() {
        let _getDocSetList = this._scheDefService.getDocSetList({ project_Id: this.projectId, group_Id: this.groupId }).subscribe((res: IDocSetModel[]) => {
            this.docSetList = res;
        });
        this.UnSubscribe.push(_getDocSetList);
    }

    /**
    * Get Element Details (Print Size,Doc Status)
    */
    public getElementDetails(elementName: string, moduleId?: number) {
        if (!moduleId)
            moduleId = Module.ScheduleDocument
        let _getProjectElementDetails = this._projService.getProjectElementDetails({ projectId: this.projectId, groupId: this.groupId, moduleId: moduleId, deDescription: elementName })
            .subscribe((res: IProjectElementDetailsOutput[]) => {
                switch (elementName) {
                    case "Print Size":
                        this.printSizeList = res;
                        if (!!this.sourceDciComponent) {
                            let printSize: IProjectElementDetailsOutput = this.sourceDciComponent.revForm.get('printSize')?.value;
                            if (!!printSize) {
                                this.selectedPrintSize = printSize.dedId;
                                this.setFormValue(this.revForm, "formPrintSize", printSize.dedDescription);
                            }
                        }
                        else if (this.printSizeList.length == 1) {
                            this.selectedPrintSize = this.printSizeList[0].dedId;
                            this.setFormValue(this.revForm, "formPrintSize", this.selectedPrintSize);
                        }
                        break;
                    case "Status":
                        this.dciStatusList = res;
                        if (!!this.sourceDciComponent) {
                            let dciStatus: IProjectElementDetailsOutput = this.sourceDciComponent.revForm.get('dciStatus')?.value;
                            if (!!dciStatus) {
                                this.selectedDciStatus = dciStatus.dedId;
                                this.setFormValue(this.revForm, "formDciStatus", dciStatus.dedDescription);
                            }
                        }
                        else if (this.dciStatusList.length == 1) {
                            this.selectedDciStatus = this.dciStatusList[0].dedId;
                            this.setFormValue(this.revForm, "formDciStatus", this.selectedDciStatus);
                        }
                        break;
                    case "Progress Level":
                        this.ProgressLevelsList = res;
                        if (!!this.sourceDciComponent) {
                            let ProgressLevels: IProjectElementDetailsOutput = this.sourceDciComponent.revForm.get('MaxProgressLevel').value;
                            if (!!ProgressLevels) {
                                this.selectedMaxProgressLevel = ProgressLevels.dedId;
                                this.setFormValue(this.revForm, "formMaxProgressLevel", ProgressLevels.dedDescription);
                            }
                        }
                        else if (this.ProgressLevelsList.length == 1) {
                            this.selectedMaxProgressLevel = this.ProgressLevelsList[0].dedId;
                            this.setFormValue(this.revForm, "formMaxProgressLevel", this.selectedMaxProgressLevel);
                        }
                        break;
                }
            }, err => { });
        this.UnSubscribe.push(_getProjectElementDetails);
    }

    /**
    * Get ApproverList
    */
    public getApproverList() {
        let _getProjectFeatureWiseMembers = this._projService.getProjectFeatureWiseMembers({ projectId: this.projectId, groupId: this.groupId, featureDescription: 'Approve' })
            .subscribe((res: IProjectFeatureOutput[]) => {
                this.approverList = res;
                if (!!this.sourceDciComponent) {
                    let approver: IProjectFeatureOutput = this.sourceDciComponent.revForm.get('authorisedBy')?.value;
                    if (!!approver) {
                        this.selectedAuthorisedBy = approver.memberId;
                        this.setFormValue(this.revForm, "formAuthorisedBy", this.selectedAuthorisedBy);
                    }
                }
                else if (this.approverList.length == 1) {
                    this.selectedAuthorisedBy = this.approverList[0].memberId;
                    this.setFormValue(this.revForm, "formAuthorisedBy", this.selectedAuthorisedBy);
                }
            }, err => { });
        this.UnSubscribe.push(_getProjectFeatureWiseMembers);
    }

    setFormValue(form: FormGroup, formControlName: string, value: any) {
        form.get(formControlName)?.setValue(value);
    }

    onselectedValueChange(val: any, formGroupName: string, formControlName: string) {
        switch (formGroupName) {
            case "docScheduleForm":
                this.docScheduleForm.get(formControlName)?.setValue(val.additionalValues.additionalValues);
                break;
            case "dciForm":
                this.dciForm.get(formControlName)?.setValue(val.additionalValues.additionalValues);
                break;
            case "revForm":
                this.revForm.get(formControlName)?.setValue(val.additionalValues.additionalValues);
                break;
        }
        if (formControlName == 'workflow') {
            if (val.additionalValues.additionalValues && val.additionalValues.additionalValues.sub_Workflow) {
                this.WTemplateStage = val.additionalValues.additionalValues.sub_Workflow.split(',');
                this.stageload();
            } else {
                this.WTemplateStage = [];
            }
        }
    }

    collapseAllClick() {
        this.panelOpenState = !this.panelOpenState;
    }

    onStageChange(event: any, stageEleDetail: IStageElementDetails) {
        if (event.checked) {
            let selDate: any = stageEleDetail.selected_Date;
            if (selDate == null)
                selDate = stageEleDetail.end_Date;
            this.scheduleWFPlanStageDetails.push({ sort_By: stageEleDetail.sort_By, status_Id: stageEleDetail.stage_Id, scheduled_On: selDate });
        }
        else {
            let schWfpStageDetails: IScheduleWFPlanStageDetails = this.scheduleWFPlanStageDetails.filter(x => x.status_Id == stageEleDetail.stage_Id)[0];
            if (!!this.scheduleWFPlanStageDetails) {
                let index: number = this.scheduleWFPlanStageDetails.indexOf(schWfpStageDetails);
                if (index > -1)
                    this.scheduleWFPlanStageDetails.splice(index, 1);
            }
        }
        if (this.scheduleWFPlanStageDetails.length > 0) {
            let firstStage: IScheduleWFPlanStageDetails = this.scheduleWFPlanStageDetails.sort((a, b) => a.sort_By - b.sort_By)[0];
            if (!!firstStage && !!this.dciRevisionList && this.dciRevisionList.length > 0) {
                let revision: any = this.dciRevisionList.filter(x => x.stageId == firstStage.status_Id && x.isActive)[0].revisionNo;
                if (!!revision)
                    this.revForm.get('revision')?.setValue(revision);
            }
        }
    }

    getDciNUmber(): string {
        let docNo: string = this.getFormValue(this.dciForm, "dciSerialNo");
        if (this.numFormat == 'Auto' || this.numFormat == 'Semi')
            return docNo + '-' + this.getFormValue(this.dciForm, "dciSemiNo");
        else
            return docNo;
    }

    madatoryFieldsValidation() {
        if (!this.isDocSetRequired) {
            this.docScheduleForm.get('docSet')?.clearValidators();
            this.docScheduleForm.get('docSet')?.updateValueAndValidity();
            this.docScheduleForm.get('formDocSet')?.clearValidators();
            this.docScheduleForm.get('formDocSet')?.updateValueAndValidity();
        }
        let revNo: string = this.getFormValue(this.revForm, "revision");
        if (this.isStdDCI) {
            if (!(this.dynamicForm.form.valid && this.dciForm.valid && this.revForm.valid)) {
                let result: StandardOutputModel = { result: "", successCode: 400, successMessage: this.docIndex + " - " + "Mandatory fields are missing" };
                this.formMarkAsTouched(this.dynamicForm.form);
                this.formMarkAsTouched(this.dciForm);
                this.formMarkAsTouched(this.revForm);
                return result
            }
        } else {
            let result: StandardOutputModel = { result: "", successCode: 400, successMessage: this.docIndex + " - " + "Mandatory fields are missing" };
            if (this.scheduleWFPlanStageDetails && this.scheduleWFPlanStageDetails.length <= 0) {
                let result: StandardOutputModel = { result: "", successCode: 400, successMessage: (this.docIndex == 1 ? '' : this.docIndex + " - ") + "Kindly select atleast one stage." };
                return result;
            }
            if (revNo.length == 0) {
                let result: StandardOutputModel = { result: "", successCode: 400, successMessage: (this.docIndex == 1 ? '' : this.docIndex + " - ") + "Revision number is mandatory" };
                return result;
            }
            if (!(this.dynamicForm.form.valid && this.dciForm.valid && this.revForm.valid && this.docScheduleForm.valid)) {
                this.formMarkAsTouched(this.dynamicForm.form);
                this.formMarkAsTouched(this.dciForm);
                this.formMarkAsTouched(this.revForm);
                this.formMarkAsTouched(this.docScheduleForm);
                return result
            }
        }
    }

    /**
    * Save DCI Document
    */
    docnumber!: string;
    async saveDocument(): Promise<StandardOutputModel> {

        if (!!this.isWBSIntegration) {
            if (!!this.WBSCode) {
                if (!!this.DeliverableCode) {

                } else {
                    this._notificationService.showPopup("Kindly select Deliverable Code", "Warning");
                    return;
                }
            }
        }

        let revNo: string = this.getFormValue(this.revForm, "revision");
        let result: StandardOutputModel = { result: "", successCode: 400, successMessage: this.docIndex + " - " + "Mandatory fields are missing" };

        if (!this.isStdDCI) {

            if (this.scheduleWFPlanStageDetails && this.scheduleWFPlanStageDetails.length <= 0) {
                let result: StandardOutputModel = { result: "", successCode: 400, successMessage: (this.docIndex == 1 ? '' : this.docIndex + " - ") + "Kindly select atleast one stage." };
                return result;
            }
            if (revNo.length == 0) {
                let result: StandardOutputModel = { result: "", successCode: 400, successMessage: (this.docIndex == 1 ? '' : this.docIndex + " - ") + "Revision number is mandatory" };
                return result;
            }

        }

        if (this.isStdDCI) {
            if (this.dynamicForm.form.valid && this.dciForm.valid && this.revForm.valid) {
                let semiNo: string = '0';
                let docNo: string = this.getFormValue(this.dciForm, "dciSerialNo");
                this.docnumber = docNo;
                if (this.numFormat == 'Semi' || this.numFormat == 'Auto') {
                    semiNo = this.getFormValue(this.dciForm, "dciSemiNo");
                    semiNo = semiNo.replace(/\D|^0+/g, "");
                    docNo = docNo + '-' + this.getFormValue(this.dciForm, "dciSemiNo");
                    this.docnumber = docNo;
                }
                let scheduleDocInput: IScheduleDocModel = {
                    projectId: this.projectId,
                    groupId: this.groupId,
                    docNo: docNo,
                    docSerialNo: +semiNo,
                    docTitle: this.getFormValue(this.dciForm, "title"),
                    userId: this.memberId,
                    module: Module.ScheduleDocument
                };

                let docSet: IDocSetModel = this.getFormValue(this.docScheduleForm, "docSet");
                if (!!docSet)
                    scheduleDocInput.docSetId = docSet.doc_Set_Id;
                let schBulkInsertModel: IScheduleBulkInsertModel;
                schBulkInsertModel = {
                    isStandardDrawingDocument: this.isStdDCI,
                    dciMasterDetails: scheduleDocInput,
                    dciRevDetails: this.getScheduleDocRevision(),
                    dciSchDetails: this.getScheduleDocDetails(),
                    dciElementDetails: this.getScheduleDocEleDetails(),
                    dciDocScheduleWFPlanDetails: null, //this.getScheduleDocWFPlanDetails(), 
                    dciDocSchMHDetails: this.getScheduleMHDetails(),
                    dciDocSchStageDetails: null, //this.getScheduleRevStageDetails(),
                    dciDocSchWorkflowDetails: null //this.getScheduleDocWorkflowDetails()
                }

                result = await this._scheduleDocService.InsertScheduleBulkDocument(schBulkInsertModel).toPromise();

                if (!!this.isWBSIntegration) {
                    if (result.successCode == 200 || result.successCode == 205) {
                        let dciCPCDocDetails: ICPCInputModel = {
                            docId: +result.result,
                            projectId: this.projectId,
                            memberId: this.memberId,
                            wBSCode: this.WBSCode,
                            deliverableCode: this.DeliverableCode
                        }
                        let result1: StandardOutputModel = await this._scheduleDocService.InsertCPCDocDetails(dciCPCDocDetails).toPromise();
                    }
                }
            }
            else {
                this.formMarkAsTouched(this.dynamicForm.form);
                this.formMarkAsTouched(this.dciForm);
                this.formMarkAsTouched(this.revForm);
            }
        }
        else {
            if (this.dynamicForm.form.valid && this.dciForm.valid && this.revForm.valid && this.docScheduleForm.valid) {
                if (this.scheduleWFPlanStageDetails.length > 0) {
                    let semiNo: string = '0';
                    let docNo: string = this.getFormValue(this.dciForm, "dciSerialNo");
                    if (this.numFormat == 'Semi' || this.numFormat == 'Auto') {
                        semiNo = this.getFormValue(this.dciForm, "dciSemiNo");
                        semiNo = semiNo.replace(/\D|^0+/g, "");
                        docNo = docNo + '-' + this.getFormValue(this.dciForm, "dciSemiNo");
                    }
                    let scheduleDocInput: IScheduleDocModel = {
                        projectId: this.projectId,
                        groupId: this.groupId,
                        docNo: docNo,
                        docSerialNo: +semiNo,
                        docTitle: this.getFormValue(this.dciForm, "title"),
                        userId: this.memberId,
                        module: Module.ScheduleDocument,
                        MaxProgressLevel: !!this.SetDCIMaxProgressLevel && this.getFormValue(this.docScheduleForm, "MaxProgressLevel") ? this.getFormValue(this.docScheduleForm, "MaxProgressLevel").dedId : null

                    };
                    let docSet: IDocSetModel = this.getFormValue(this.docScheduleForm, "docSet");
                    if (!!docSet)
                        scheduleDocInput.docSetId = docSet.doc_Set_Id;
                    let schBulkInsertModel: IScheduleBulkInsertModel;
                    schBulkInsertModel = {
                        isStandardDrawingDocument: false,
                        dciMasterDetails: scheduleDocInput,
                        dciRevDetails: this.getScheduleDocRevision(),
                        dciSchDetails: this.getScheduleDocDetails(),
                        dciElementDetails: this.getScheduleDocEleDetails(),
                        dciDocScheduleWFPlanDetails: this.getScheduleDocWFPlanDetails(),
                        dciDocSchMHDetails: this.getScheduleMHDetails(),
                        dciDocSchStageDetails: this.getScheduleRevStageDetails(),
                        dciDocSchWorkflowDetails: this.getScheduleDocWorkflowDetails()

                    }
                    result = await this._scheduleDocService.InsertScheduleBulkDocument(schBulkInsertModel).toPromise();

                    if (!!this.isWBSIntegration) {
                        if (result.successCode == 200 || result.successCode == 205) {
                            let dciCPCDocDetails: ICPCInputModel = {
                                docId: +result.result,
                                projectId: this.projectId,
                                memberId: this.memberId,
                                wBSCode: this.WBSCode,
                                deliverableCode: this.DeliverableCode
                            }
                            let result1: StandardOutputModel = await this._scheduleDocService.InsertCPCDocDetails(dciCPCDocDetails).toPromise();
                        }
                    }

                }
                else {
                    this._notificationService.showPopup("Kindly select atleast one stage", "Warning");
                }
            }
            else {
                this.formMarkAsTouched(this.dynamicForm.form);
                this.formMarkAsTouched(this.dciForm);
                this.formMarkAsTouched(this.revForm);
                this.formMarkAsTouched(this.docScheduleForm);
            }
        }
        if (this.isStdDCI && result.successCode == 200) {
            let docdata = result;
            const dialog = this.dialog.open(FileUploadComponent, {
                panelClass: 'mat-dialog-secondary',
                width: '50%',
                data: {
                    projectId: 0,
                    docId: docdata.result,
                    revisionNo: this.getFormValue(this.revForm, "revision").toString(),
                    moduleName: 'EDMS',
                    libraryName: FileUploadLibrary.WorkflowDocument,
                    createdBy: this.memberId,
                    documents: [{
                        value: docdata.result,
                        text: this.docnumber,
                        revisionNo: this.getFormValue(this.revForm, "revision").toString(),
                        task_SNo: 1
                    }],
                    isEditable: false
                },
            });
            dialog.afterClosed().subscribe((res: any) => {
            });
        }
        return result;
    }

    formMarkAsTouched(form: FormGroup) {
        if (!form.valid)
            Object.keys(form.controls).forEach(key => {
                form.get(key)?.markAsTouched();
            });
    }

    private getScheduleDocRevision(): IScheduleDocRevModel {
        let scheduleDocRevInput: IScheduleDocRevModel = {
            docId: 0,
            revisionNo: this.getFormValue(this.revForm, "revision"),
            docStatus: this.getFormValue(this.revForm, "dciStatus").dedId,
            isConfidential: this.getFormValue(this.revForm, "isConfidential"),
            printSize: this.getFormValue(this.revForm, "printSize").dedId,
            docAuthorizedBy: this.getFormValue(this.revForm, "authorisedBy").memberId,
            revisionCategory: this.getFormValue(this.revForm, "revCategory").revCategoryId,
            qrCodeStatus: this.getFormValue(this.revForm, "qrCodeTag"),
            comments: this.getFormValue(this.revForm, "comments"),
            reference: this.getFormValue(this.revForm, "reference"),
            noOfSheets: this.getFormValue(this.revForm, "noOfSheets"),
            revisionType: 0,
            docCreatedBy: this.memberId,
            createdBy: this.memberId,
            isActive: true
        }
        return scheduleDocRevInput;
    }

    private getScheduleDocEleDetails(): IScheduleElementDetails {
        let scheduleDocEleDetails: IScheduleDocElementDetails[] = [];
        let resForm: FormGroup = this.dynamicForm.value;
        scheduleDocEleDetails = this.projectElements.map(x => {
            let selectedValue: IProjectElementDetailsOutput = resForm.get(x.elementDescription)?.value;
            let result: IScheduleDocElementDetails = {
                deId: x.elementId,
                dedId: selectedValue.dedId,
                userId: this.memberId,
                isActive: true,
                docId: 0
            }
            return result;
        });
        let elmentDetails: IScheduleElementDetails = { elementDetailsMapping: scheduleDocEleDetails };
        return elmentDetails;
    }

    private getScheduleDocWFPlanDetails(): IScheduleWFPlanDetails {
        let schWFPlandetails: IScheduleWFPlanDetails = {
            doc_Id: 0,
            revision_No: this.getFormValue(this.revForm, "revision"),
            docScheduleWFPlanDetails: this.scheduleWFPlanStageDetails,
            is_Active: true,
            userId: this.memberId
        }
        return schWFPlandetails;
    }

    private getScheduleRevStageDetails(): IScheduleDocStageDetails {
        let schDocStageDetails: IScheduleDocStageDetails = {
            doc_Id: 0,
            revision_No: this.getFormValue(this.revForm, "revision"),
            docScheduleStageDetails: this.scheduleWFPlanStageDetails.map(x => {
                let stage: IScheduleStageId = {
                    stage_Id: x.status_Id
                }
                return stage;
            }),
            stage_Id: this.scheduleWFPlanStageDetails.sort((a, b) => a.sort_By - b.sort_By)[0].status_Id,
            is_Active: true,
            userId: this.memberId
        }
        return schDocStageDetails;
    }

    private getScheduleMHDetails(): IScheduleMHDetails {
        let eManHours: any = this.getFormValue(this.dciForm, "enggManhours");
        let dManHours: any = this.getFormValue(this.dciForm, "draftingManHours");
        let weightage: any = this.getFormValue(this.dciForm, "weightage");

        let schDocMHDetails: IScheduleMHDetails = {
            doc_Id: 0,
            e_Man_Hours: !!eManHours ? eManHours : 0,
            d_Man_Hours: !!dManHours ? dManHours : 0,
            weightage: !!weightage ? weightage : 0,
            userId: this.memberId,
            is_Active: true
        }
        return schDocMHDetails;
    }

    private getScheduleDocDetails(): IScheduleDocDetails {
        let schDocDetails: IScheduleDocDetails = {
            doc_Id: 0,
            from_Group_Id: this.groupId,
            to_Group_Id: this.getFormValue(this.docScheduleForm, "approvalBy").group_Id,
            revision_No: this.getFormValue(this.revForm, "revision"),
            schedule_Type: this.getFormValue(this.dciForm, "schType").schType_Id,
            is_Input_Required: this.getFormValue(this.dciForm, "inputRequired").value,
            userId: this.memberId,
            is_Active: true
        }
        return schDocDetails;
    }

    private getScheduleDocWorkflowDetails(): IScheduleWorkflowDetails {
        let schDocWorkflowDetails: IScheduleWorkflowDetails = {
            doc_Id: 0,
            userId: this.memberId,
            is_Active: true,
            workflow_Id: this.getFormValue(this.docScheduleForm, "workflow").workflowId,
            revision_No: this.getFormValue(this.revForm, "revision")
        }
        return schDocWorkflowDetails;
    }

    private getFormValue(form: FormGroup, formControlName: string): any {
        return form.get(formControlName)?.value;
    }

    private getStructureDiscElementId() {
        let _getProjectElementIdByDescription = this._projService.getProjectElementIdByDescription('Structure / Package').subscribe(x => {
            this.structPackEleId = x.deId;
        });
        let __getProjectElementIdByDescription = this._projService.getProjectElementIdByDescription('Discipline').subscribe(x => {
            this.discEleId = x.deId;
        });
        this.UnSubscribe.push(_getProjectElementIdByDescription, __getProjectElementIdByDescription);
    }

    private buildScheduleDocumentNumber() {
        let resForm: FormGroup = this.dynamicForm.value;
        //Numbering elements array
        let numberingElements: string[] = Array.from(this.numElements.keys());
        numberingElements.forEach(element => {
            resForm.get(element)?.valueChanges.subscribe((x: IProjectElementDetailsOutput) => {

                if (this.numElements.has(element)) {
                    if (!!x) {
                        this.numElements.set(element, x.dedShortDescription);
                    }
                    else {
                        this.numElements.set(element, '');
                    }
                }
                if (this.numFormat == 'Auto' || this.numFormat == 'Semi') {
                    this.GetDocumentSerialNo();
                }
                if (this.isDocSetRequired && !!x) {
                    if (x.deId == this.structPackEleId || x.deId == this.discEleId)
                        this.filterDocSet(x);
                }
            });
        });
    }

    private subscribeDiscStructureChanges() {
        let resForm: FormGroup = this.dynamicForm.value;
        let structDiscFields: FieldConfig[] = this.elementsConfig.filter(x => x.de_id == this.discEleId || x.de_id == this.structPackEleId);
        structDiscFields.forEach(element => {
            if (element.deDescription)
                resForm.get(element.deDescription)?.valueChanges.subscribe((x: IProjectElementDetailsOutput) => {
                    if (!!x)
                        this.filterDocSet(x);
                })
        })
    }

    private filterDocSet(elementDetail: IProjectElementDetailsOutput) {
        if (elementDetail.deId == this.structPackEleId)
            this.structSelectedDedId = elementDetail.dedId;
        else if (elementDetail.deId == this.discEleId)
            this.discSelectedDedId = elementDetail.dedId;
        //reset the last selected document set
        this.selectedDocSetStageDetails = [];
        this.selectedDocSetStageDetailsCopy = [];
        this.scheduleWFPlanStageDetails = [];
        this.stageDates.clear();
        this.filteredDocSetList = this.docSetList.filter(ds => ds.structure_DED_Id == this.structSelectedDedId &&
            ds.disc_DED_Id == this.discSelectedDedId);
        if (!!this.sourceDciComponent) {
            if (this.isDocSetRequired)
                this.filteredDocSetList = this.sourceDciComponent.filteredDocSetList;
            let docSet: IDocSetModel = this.sourceDciComponent.docScheduleForm.get('docSet')?.value;
            if (!!docSet) {
                this.selectedDocSet = docSet.doc_Set_Id;
                this.setFormValue(this.docScheduleForm, "formDocSet", this.selectedDocSet);
            }
        }
    }

    private loadStages() {
        this.docScheduleForm.get('docSet')?.valueChanges.subscribe((res: IDocSetModel) => {
            if (!!res) {
                //reset the last selected document set
                this.selectedDocSetStageDetails = [];
                this.selectedDocSetStageDetailsCopy = [];
                this.scheduleWFPlanStageDetails = [];
                this.stageDates.clear();
                this.selectedDocSetStageDetailsCopy = this.selectedDocSetStageDetails = res.stageDocumentSetDetails.filter(x => x.end_Date != null);

                if (this.WTemplateStage && this.WTemplateStage.length > 0) {
                    let obj: IStageElementDetails[] = [];
                    this.selectedDocSetStageDetails.forEach((val, index) => {
                        if (this.WTemplateStage.some((x: number | undefined) => x == val.stage_Id))
                            obj.push(val)
                    });
                    this.selectedDocSetStageDetailsCopy = this.selectedDocSetStageDetails = obj;
                    this.revForm.get('revision')?.setValue('');
                    if (this.selectedDocSetStageDetails && this.selectedDocSetStageDetails.length < 1)
                        this._notificationService.showToast("Some mismatch in between the selected workflow and document set, please check corresponding configuration.", "Warning");
                }

                this.selectedDocSetStageDetails.forEach(x => {
                    if (x.end_Date != null) {
                        let stageDate: IStageDates = {
                            minDate: new Date(x.start_Date),
                            maxDate: new Date(x.end_Date),
                            value: (Date.parse(new Date().toString()) <= Date.parse(x.end_Date) && Date.parse(new Date().toString()) >= Date.parse(x.start_Date)) && !this.isDocSetRequired ? new Date() : new Date(x.end_Date)
                        };
                        if (x.stage_Id)
                            this.stageDates.set(x.stage_Id.toString(), stageDate)
                        let _stageDate = this._datepipe.transform(stageDate.value, 'dd-MMM-yyyy');
                        if (_stageDate)
                            x.selected_Date = _stageDate;
                    }
                });
                this.selectedDocSetStageDetailsCopy = this.selectedDocSetStageDetails;

                if (!!this.sourceDciComponent && this.sourceDciComponent.scheduleWFPlanStageDetails.length > 0) {
                    this.scheduleWFPlanStageDetails = [];
                    this.selectedDocSetStageDetails = this.sourceDciComponent.selectedDocSetStageDetailsCopy;
                    this.sourceDciComponent.scheduleWFPlanStageDetails.forEach(x => {
                        let stageDetail = this.selectedDocSetStageDetails.filter(y => y.stage_Id == x.status_Id)[0];
                        if (!!stageDetail) {
                            stageDetail.checked = true;
                            this.scheduleWFPlanStageDetails.push({ sort_By: x.sort_By, status_Id: x.status_Id, scheduled_On: x.scheduled_On });
                        }
                    })
                    this.selectedDocSetStageDetailsCopy = this.selectedDocSetStageDetails
                }
            }
        })
    }

    private async loadWorkflowStages() {
        this.docScheduleForm.get('workflow')?.valueChanges.subscribe(async (res: WorkflowTemplateModel) => {
            if (!!res) {
                await this._scheduleDocService.GetWorkflowStageDetails({ project_Id: res.projectId, workflow_Id: res.workflowId }).toPromise().then((stages: IStageElementDetails[]) => {
                    this.selectedDocSetStageDetails = [];
                    this.scheduleWFPlanStageDetails = [];
                    this.stageDates.clear();
                    this.selectedDocSetStageDetails = stages.filter(x => x.is_Active == true);
                    //stage_Short_Description
                    this.selectedDocSetStageDetails.forEach(x => {
                        let stageDate: IStageDates = {
                            minDate: new Date(x.start_Date),
                            maxDate: new Date(x.end_Date),
                            value: (Date.parse(new Date().toString()) <= Date.parse(x.end_Date) && Date.parse(new Date().toString()) >= Date.parse(x.start_Date)) && !this.isDocSetRequired ? new Date() : new Date(x.end_Date)
                        };
                        if (x.stage_Id)
                            this.stageDates.set(x.stage_Id.toString(), stageDate)
                        let _stageDate = this._datepipe.transform(stageDate.value, 'dd-MMM-yyyy')
                        if (_stageDate)
                            x.selected_Date = _stageDate;
                    });
                    this.selectedDocSetStageDetailsCopy = this.selectedDocSetStageDetails;
                    if (!!this.sourceDciComponent && this.sourceDciComponent.scheduleWFPlanStageDetails.length > 0) {
                        this.scheduleWFPlanStageDetails = [];
                        this.selectedDocSetStageDetails = this.sourceDciComponent.selectedDocSetStageDetailsCopy;
                        this.sourceDciComponent.scheduleWFPlanStageDetails.forEach(x => {
                            let stageDetail = this.selectedDocSetStageDetails.filter(y => y.stage_Id == x.status_Id)[0];
                            if (!!stageDetail) {
                                stageDetail.checked = true;
                                this.scheduleWFPlanStageDetails.push({ sort_By: x.sort_By, status_Id: x.status_Id, scheduled_On: x.scheduled_On });
                            }
                            // if(x.status_Id)
                            //     this.stageDates.set(x.status_Id.toString(),new Date(stageDetail.selected_Date))
                            //this.stageDates[x.status_Id].value = new Date(stageDetail.selected_Date)
                            if (x.status_Id && stageDetail.selected_Date) {
                                let x: any = new Date(stageDetail.selected_Date)
                                this.stageDates.set(x.status_Id.toString(), x);
                            }
                        })
                        this.selectedDocSetStageDetailsCopy = this.selectedDocSetStageDetails
                    }
                })
            }
        })
    }

    getStageDate(selectedStageDate: any, stage: IStageElementDetails) {
        if (!this.sourceDciComponent) {
            stage.selected_Date = selectedStageDate.value;

            if (stage.stage_Id && selectedStageDate.value) {
                let x: any = new Date(selectedStageDate.value)
                this.stageDates.set(stage.stage_Id.toString(), x);
            }
            if (this.scheduleWFPlanStageDetails.length > 0) {
                let scheduleWfPlan: IScheduleWFPlanStageDetails = this.scheduleWFPlanStageDetails.filter(x => x.status_Id == stage.stage_Id)[0];
                scheduleWfPlan.scheduled_On = stage.selected_Date;
            }
        }
        if (!!this.sourceDciComponent) {
            if (stage.stage_Id) {
                let x: any = new Date(selectedStageDate.value)
                this.stageDates.set(stage.stage_Id.toString(), x);
            }
            this.scheduleWFPlanStageDetails.map(val => {
                if (val.status_Id == stage.stage_Id) {
                    val.status_Id = stage.stage_Id;
                    val.scheduled_On = selectedStageDate.value;
                    val.sort_By = stage.sort_By;
                }
            })
        }
    }

    private enableDisableSerialNo(semiNoUpdateRequired: boolean) {
        this.isShowSerialNo = this.numFormat == 'Semi' || this.numFormat == 'Auto';
        if (!!this.dciForm) {
            if (this.numFormat == 'Auto') {
                this.dciForm.get('dciSemiNo')?.disable();
                this.dciForm.get('dciSerialNo')?.disable();
                if (semiNoUpdateRequired)
                    this.GetDocumentSerialNo();
            }
            else if (this.numFormat == 'Semi') {
                this.dciForm.get('dciSemiNo')?.enable();
                this.dciForm.get('dciSerialNo')?.disable();
                if (semiNoUpdateRequired)
                    this.GetDocumentSerialNo();
            }
            else if (this.numFormat == 'Manual') {
                this.dciForm.get('dciSerialNo')?.setValue('');
                this.dciForm.get('dciSemiNo')?.setValue('');
                this.dciForm.get('dciSerialNo')?.enable();
                this.dciForm.get('dciSemiNo')?.disable();
            }
        }
    }

    private copyElementDetailsFromSource() {
        let sourceProjElementForm: FormGroup = this.sourceDciComponent.dynamicForm.value;
        this.projectElements.forEach(x => {
            let selectedValue: IProjectElementDetailsOutput = sourceProjElementForm.get(x.elementDescription)?.value;
            if (!!selectedValue) {
                let field: FieldConfig = this.elementsConfig.find(ele => ele.de_id == selectedValue.deId && ele.deDescription == selectedValue.deDescription);
                if (!!field) {
                    field.value.next(selectedValue.dedId);
                }
            }
        })
    }

    private copyGeneralDetails() {
        let sourceDciForm: FormGroup = this.sourceDciComponent.dciForm;
        let sourceRevForm: FormGroup = this.sourceDciComponent.revForm;
        let sourceDocScheduleForm: FormGroup = this.sourceDciComponent.docScheduleForm;

        let enggManHours: number = sourceDciForm.get('enggManhours')?.value;
        if (!!enggManHours)
            this.dciForm.get('enggManhours')?.setValue(enggManHours);

        let draftingManHours: number = sourceDciForm.get('draftingManHours')?.value;
        if (!!draftingManHours)
            this.dciForm.get('draftingManHours')?.setValue(draftingManHours);

        let weightage: number = sourceDciForm.get('weightage')?.value;
        if (!!weightage)
            this.dciForm.get('weightage')?.setValue(weightage);

        let isConfidential: boolean = sourceRevForm.get('isConfidential')?.value;
        this.revForm.get('isConfidential')?.setValue(isConfidential);

        let revision: string = sourceRevForm.get('revision')?.value;
        if (!!revision)
            this.revForm.get('revision')?.setValue(revision);

        let reference: string = sourceRevForm.get('reference')?.value;
        if (!!reference)
            this.revForm.get('reference')?.setValue(reference);

        let noOfSheets: number = sourceRevForm.get('noOfSheets')?.value;
        if (!!noOfSheets)
            this.revForm.get('noOfSheets')?.setValue(noOfSheets);

        let qrCodeTag: boolean = sourceRevForm.get('qrCodeTag')?.value;
        this.revForm.get('qrCodeTag')?.setValue(qrCodeTag);

        let comments: string = sourceRevForm.get('comments')?.value;
        if (!!comments)
            this.revForm.get('comments')?.setValue(comments);
    }

    async getProjectStaticElements() {
        await this._projService.getProjectElements({ projectId: this.projectId, groupId: this.groupId, moduleId: Module.ScheduleDocument, IsQueryForStaticElement: true }).toPromise().then(
            (res: IProjectElementsOutput[]) => {
                if (res.length > 0) {
                    this.projectStaticElements = res;
                    let revElement: IProjectElementsOutput[] = this.projectStaticElements.filter(x => x.elementDescription == "Auto Revision");
                    if (revElement.length > 0) {
                        this.isAutoRevision = revElement[0].isDefaultSelect;
                    }
                    // let isDocSetRequiredElement = this.projectStaticElements.filter(x => x.elementDescription == "IsDocSetRequired")[0];
                    // if (!!isDocSetRequiredElement) {
                    //     this.isDocSetRequired = isDocSetRequiredElement.isMandatory;
                    //     if (!this.isDocSetRequired) {
                    //         this.IsDisabled = false;
                    //     }
                    // }


                    let isWBSIntegrationElement = this.projectStaticElements.filter(x => x.elementDescription == "WBS Integration")[0];
                    if (!!isWBSIntegrationElement) {
                        this.isWBSIntegration = isWBSIntegrationElement.isMandatory;
                    }

                    let isDocSetRequired: IProjectElementsOutput = this.projectStaticElements.filter(x => x.elementDescription == "IsDocSetRequired")[0];
                    if (!!isDocSetRequired)
                        if (isDocSetRequired.isVisible)
                            this.isDocSetRequired = isDocSetRequired;
                            if (!this.isDocSetRequired) {
                                        this.IsDisabled = false;
                                    }

                    let SetDCIMaxProgressLevel: IProjectElementsOutput = this.projectStaticElements.filter(x => x.elementDescription == "Set DCI Max Progress Level")[0];
                    if (!!SetDCIMaxProgressLevel)
                        if (SetDCIMaxProgressLevel.isVisible)
                            this.SetDCIMaxProgressLevel = SetDCIMaxProgressLevel;
                }
            }, err => {
                this._notificationService.showToast("failed to get static element details", "Warning");
            });
        if (this.isDocSetRequired)
            this.getDocSetList();
    }

    resetScheduleForm() {
        this.dciSerialNo = null;
        this.selectedDocSetStageDetails = [];
        this.WTemplateStage = [];
        this.selectedDocSetStageDetailsCopy = [];
        this.scheduleWFPlanStageDetails = [];
        this.projBusinessGroups = [];
        this.revCategoryList = [];
        this.workflowList = [];
        this.docSetList = [];
        this.filteredDocSetList = [];
        this.printSizeList = [];
        this.revForm.get('revision')?.setValue('')
        this.eipAutoCompleteComponents.forEach(x => x.clearText());
        this.ngOnInit();
    }

    // numberOnly(event, field = null): boolean {
    //     const charCode = (event.which) ? event.which : event.keyCode;
    //     if (['weightage', 'enggMH', 'draftMH'].includes(field)) {
    //         if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode != 46) {
    //             return false;
    //         } else {
    //             return true;
    //         }
    //     } else {
    //         if (charCode > 31 && (charCode < 48 || charCode > 57)) {
    //             return false;
    //         } else {
    //             return true;
    //         }
    //     }
    // }

    getWBSCodes() {
        let _getProjects = this._projectService.getProjects(this.projectId, this.memberId).subscribe((data: IProjectMasterViewModel[]) => {
            // this.JOBCode = "LE160665";
            this.JOBCode = data[0].job_Code;
            this._scheduleDocService.GetWBSCodes({ job_Code: this.JOBCode })
                .subscribe((res) => {
                    this.wbsList = res;
                });
        });
        this.UnSubscribe.push(_getProjects);
    }
    setWBSCode(event: EIPAutoCompleteEventModel<IWBSOutputModel>) {
        if (event.value != '-2') {
            this.dciForm.get('wbsCode')?.setValue(event.value);
            this.dciForm.get('wbsCode')?.setValue(event.text);
            this.WBSCode = event.value.toString();
            if (!!this.WBSCode) {
                let _GetDeliverableCodes = this._scheduleDocService.GetDeliverableCodes({ job_Code: this.JOBCode, wBS_Code: this.WBSCode })
                    .subscribe((res) => {
                        this.dvcodeList = res;
                    });
                this.UnSubscribe.push(_GetDeliverableCodes);
            }

        }
        else {
            this.dciForm.get('wbsCode')?.setValue(null);
            this.dvcodeList = [];
            this.WBSCode = null;
            this.DeliverableCode = null;
        }
    }
    setDVCode(event: EIPAutoCompleteEventModel<ICPCDocOutputModel>) {
        if (event.value != '-2') {
            this.dciForm.get('dvCode')?.setValue(event.value);
            this.dciForm.get('dvCode')?.setValue(event.text);
            this.DeliverableCode = +event.value
        }
        else {
            this.dciForm.get('dvCode')?.setValue(null);
            this.DeliverableCode = null
        }
    }

    changeAutoStatus(event?: any) {
        if (event.checked || event == true) {
            this.revForm.get('revision')?.disable();
        }
        else {
            this.revForm.get('revision')?.enable();
        }
    }
    stageload() {
        if (this.selectedDocSetStageDetailsCopy && this.selectedDocSetStageDetailsCopy.length && this.WTemplateStage && this.WTemplateStage.length > 0 && !this.sourceDciComponent) {
            let obj: IStageElementDetails[] = [];
            this.selectedDocSetStageDetailsCopy.forEach((val, index) => {
                if (this.WTemplateStage.some((x: number | undefined) => x == val.stage_Id)) {
                    val.checked = false;
                    obj.push(val)
                }
            });

            this.selectedDocSetStageDetails = obj;
            this.revForm.get('revision')?.setValue('');
            if (this.selectedDocSetStageDetails && this.selectedDocSetStageDetails.length < 1)
                this._notificationService.showToast("Some mismatch in between the selected workflow and document set, please check corresponding configuration.", "Warning");
        }
    }

    // public validation(event:any,type:string){
    //     var value = event.target.value
    //     // type ==  'enggManhours' && value.length > 8 ? this.dciForm.get('enggManhours')?.setValue('') : type == 'draftingManHours' && value.length > 8 ? 
    //     // this.dciForm.get('draftingManHours')?.setValue('') : type == 'weightage' && value.length > 8 ? this.dciForm.get('weightage')?.setValue('') : console.log("nothing")
    //     if(type ==  'enggManhours' && value.length > 8){
    //         this.dciForm.get('enggManhours')?.setValue('');
    //         this.validationMsg = true 
    //     }else if(type == 'draftingManHours' && value.length > 8){
    //         this.dciForm.get('draftingManHours')?.setValue('');
    //         this.validationMsg = true
    //     }else if(type == 'weightage' && value.length > 7){
    //         this.dciForm.get('weightage')?.setValue('');
    //         this.validationMsg = true
    //     }else{
    //         this.validationMsg = false
    //     }

    // }

    ngOnDestroy(): void {

        this.UnSubscribe.forEach(x => x.unsubscribe());
    }

}